
































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { sessionModule } from '@/trials/store/modules/session';
import { SysConst as SC } from '@/trials/plugins/const';
import ConfirmDialogData from '@/trials/domain/objects/confirmDialogData';

@Component
export default class TrialsMenu extends Vue {
    /*----------------------------------*
     * Data
     *-----------------------------------*/
    private isCheatSheets: boolean = false;
    /*----------------------------------*
     * Computed
     *-----------------------------------*/
    // アクティブコンテンツ
    private get currentContent() {
        return sessionModule.getCurrentRouterViewTrials;
    }

    /* Active, Disabledフラグ
        --------------------------*/
    // 学習の準備
    private get activeTrainData(): boolean {
        return this.$route.path.startsWith(SC.Path.TRAIN_DATA_MENU);
    }
    private get disabledTrainData() {
        return this.activeTrainData;
    }

    // KC確認
    private get activeKCList(): boolean {
        return this.$route.path.startsWith(SC.Path.TRAIN_KC_MENU);
    }
    private get disabledKCList() {
        return this.activeKCList || !this.isListed;
    }

    // 学習結果
    private get activeTrainResult(): boolean {
        return this.$route.path.startsWith(SC.Path.TRAIN_RESULT_MENU);
    }
    private get disabledTrainResult() {
        return this.activeTrainResult || !this.isTrained;
    }

    // 予測の準備
    private get activePredictData(): boolean {
        return this.$route.path.startsWith(SC.Path.PREDICT_DATA_MENU);
    }
    private get disabledPredictData() {
        return this.activePredictData || !this.enabledPredictPhase;
    }

    // 予測結果
    private get activePredictResult(): boolean {
        return this.$route.path.startsWith(SC.Path.PREDICT_RESULT_MENU);
    }
    private get disabledPredictResult() {
        return this.activePredictResult || !this.enabledPredictPhase || !this.isPredicted;
    }

    /* FDL様画面でプライバシーポリシー同意済
        // 同意済 フラグ
        public get isAgreed() : boolean{
            return sessionModule.getAgreed;
        };*/

    // 学習データ準備
    private get isPreparedTrainData(): boolean {
        return sessionModule.getTrainingData !== null;
    }

    // KC列挙済 フラグ
    private get isListed(): boolean {
        return sessionModule.getListed === SC.Flag.Process.DONE;
    }

    // 学習済 フラグ
    private get isTrained(): boolean {
        return sessionModule.getTrained === SC.Flag.Process.DONE;
    }

    // 予測フェーズの有効 フラグ
    private get enabledPredictPhase(): boolean {
        return sessionModule.getEnabledPredictPhase;
    }

    // 推論済 フラグ
    private get isPredicted(): boolean {
        return sessionModule.getPredicted === SC.Flag.Process.DONE;
    }

    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/
    mounted() {
        // Child コンポーネントの指定がない場合
        if (this.$route.path == SC.Path.TRIALS_MENU) {
            // Child コンポーネントへのルーティング
            this.$router.replace(this.currentContent);
        }
    }

    /*----------------------------------*
     * Methods
     *-----------------------------------*/

    // コンテンツ表示
    private viewContent(content: string) {
        sessionModule.SET_ROUTE_TRIALS(content);
        this.$router.push(this.currentContent);
    }

    /* Clickメソッド(コンテンツ切替)
        -------------------------------*/
    // 学習データ
    private toTrainData() {
        this.viewContent(SC.Path.TRAIN_DATA_MENU);
    }
    // KC列挙
    private toKCList() {
        this.viewContent(SC.Path.TRAIN_KC_MENU);
    }
    // 学習結果
    private toTrainResult() {
        this.viewContent(SC.Path.TRAIN_RESULT_MENU);
    }
    // 推論データ
    private toPredictData() {
        this.viewContent(SC.Path.PREDICT_DATA_MENU);
    }
    // 推論結果
    private toPredictResult() {
        this.viewContent(SC.Path.PREDICT_RESULT_MENU);
    }

    // リセット
    private resetAll() {
        const self = this;
        const confirm = new ConfirmDialogData(
            'trials.dialog.contents.format.all.title',
            'trials.dialog.contents.format.all.message',
            function() {
                sessionModule.format();
                // アップロード画面以外で実行された場合、アップロード画面に戻る
                if (self.$route.path != SC.Path.TRAIN_DATA_UPLOAD) {
                    self.$router.replace(SC.Path.TRAIN_DATA_UPLOAD);
                }
            }
        );
        sessionModule.showConfirmDialog(confirm);
    }
}
